/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Dropdown, Image, Tabs, TabsProps } from "antd";

import {
  SubmitEstimateType,
  SubServiceType,
} from "../../../../../PotentialDeals/ducks/types";
import Summary from "./SidebarTabs/Summary";
import ChangeList from "./SidebarTabs/ChangeList";
import { useState } from "react";
import { MoreOutlined } from "@ant-design/icons";

interface PropsType {
  newEstimate: boolean;
  textAreaContent?: string;
  setTextAreaContent?: React.Dispatch<React.SetStateAction<string>>;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  activeRecord: SubServiceType | null;
  singleGroupData: any;
  resetSidebar: () => void;
  groupedData?: any[];
  activeServiceId?: string | null;
  activeType?: string | null;
  estimateChanges?: any[];
  apiData?: SubmitEstimateType | null;
}

export default function EstimateSidebar(props: PropsType) {
  const [finalTotalAmount, setFinalTotalAmount] = useState(0);
  const {
    setLoading,
    activeRecord,
    newEstimate,
    textAreaContent,
    groupedData,
    setTextAreaContent,
    singleGroupData,
    resetSidebar,
    activeServiceId,
    activeType,
    estimateChanges,
    apiData,
  } = props;

  const tabItems: TabsProps["items"] = [
    {
      key: "1",
      label: "Summary",
      children: (
        <Summary
          setLoading={setLoading}
          activeRecord={activeRecord}
          newEstimate={newEstimate}
          textAreaContent={textAreaContent}
          groupedData={groupedData}
          setTextAreaContent={setTextAreaContent}
          singleGroupData={singleGroupData}
          resetSidebar={resetSidebar}
          activeServiceId={activeServiceId}
          activeType={activeType}
          finalTotalAmount={finalTotalAmount}
          setFinalTotalAmount={setFinalTotalAmount}
        />
      ),
    },
    {
      key: "2",
      label: "Change list",
      children: (
        <ChangeList
          estimateChanges={estimateChanges}
          apiData={apiData}
          finalTotalAmount={finalTotalAmount}
        />
      ),
    },
  ];

  const items = [
    {
      key: "1",
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={<Image src="/images/table/edit-icon.svg" preview={false} />}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          Edit
        </Button>
      ),
    },
    {
      key: "2",
      label: (
        <Button
          type="text"
          className="delete-hover"
          icon={<Image src="/images/table/delete-icon.svg" preview={false} />}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          Delete
        </Button>
      ),
    },
  ];

  return (
    <div className="innerRight">
      <div className="contractsSidebarTabsContainer">
        <Tabs
          defaultActiveKey="1"
          items={tabItems}
          className="contractsSidebarTabs"
        />
        <Dropdown
          menu={{
            items,
          }}
          trigger={["click"]}
          placement="bottomRight"
          className="actionButton cs_button"
        >
          <Button
            onClick={(e) => {
              e.stopPropagation();
            }}
            onKeyDown={(e) => e.stopPropagation()}
            className="only_icon"
            icon={<MoreOutlined />}
          />
        </Dropdown>
      </div>
    </div>
  );
}
